import * as React from 'react';
// Ideally, we would import from the folder rather than deep imports.
// However, the icons package is very expensive to parse for the TypeScript compiler for this package AND its dependencies.
// The TSX files that are imported from are auto-generated during this package's build step. Run `yarn build --to icons` from repo root if there are import errors
import SvgAdd from '../temp/Add.gen';
import SvgAddIn from '../temp/AddIn.gen';
import SvgCancel from '../temp/Cancel.gen';
import SvgChevronDown from '../temp/ChevronDown.gen';
import SvgChevronLeft from '../temp/ChevronLeft.gen';
import SvgChevronRight from '../temp/ChevronRight.gen';
import SvgCopy from '../temp/Copy.gen';
import SvgError from '../temp/Error.gen';
import SvgErrorBadge from '../temp/ErrorBadge.gen';
import SvgFabricFolder from '../temp/FabricFolder.gen';
import SvgGroup from '../temp/Group.gen';
import SvgCheckMark from '../temp/CheckMark.gen';
import SvgInfo from '../temp/Info.gen';
import SvgMore from '../temp/More.gen';
import SvgPeopleTrust from '../temp/PeopleTrust.gen';
import SvgUneditable from '../temp/Uneditable.gen';
import SvgLoopFilled from '../temp/LoopFilled.gen';
import SvgLoopOutline from '../temp/LoopOutline.gen';
import SvgBulletedList from '../temp/BulletedList.gen';
import SvgCheckList from '../temp/CheckList.gen';
import SvgClipboardList from '../temp/ClipboardList.gen';
import SvgClipboardListQuestion from '../temp/ClipboardListQuestion.gen';
import SvgCompleted from '../temp/Completed.gen';
import SvgInsertTextBox from '../temp/InsertTextBox.gen';
import SvgNumberedList from '../temp/NumberedList.gen';
import SvgTable from '../temp/Table.gen';
import SvgVote from '../temp/Vote.gen';
import SvgTeamsChat from '../temp/TeamsChat.gen';
import SvgQuestionCircle from '../temp/QuestionCircle.gen';
import SvgWord from '../temp/WordLogo.gen';
import SvgWordLogoColor from '../temp/WordLogoColor.gen';
import SvgPowerPoint from '../temp/PowerPointLogo.gen';
import SvgPowerPointLogoColor from '../temp/PowerPointLogoColor.gen';
import SvgExcel from '../temp/ExcelLogo.gen';
import SvgExcelLogoColor from '../temp/ExcelLogoColor.gen';
import SvgConnectToWorkspace from '../temp/ConnectToWorkspace.gen';
import SvgFoundInPlaces from '../temp/FoundInPlaces.gen';
import SvgOpen from '../temp/Open.gen';
import SvgOutlookMail from '../temp/OutlookMail.gen';
import SvgShared from '../temp/Shared.gen';
import SvgShare from '../temp/Share.gen';
import SvgInformation from '../temp/Information.gen';
import SvgLinkCardActive from '../temp/LinkCardActive.gen';
import SvgLinkCardRest from '../temp/LinkCardRest.gen';
import SvgLinkUrlActive from '../temp/LinkUrlActive.gen';
import SvgLinkUrlRest from '../temp/LinkUrlRest.gen';
import SvgLoopIcon from '../temp/LoopIcon.gen';
import SvgTrello from '../temp/Trello.gen';
import SvgDelete from '../temp/Delete.gen';
import SvgJira from '../temp/Jira.gen';
import SvgClover from '../temp/Clover.gen';
import SvgCloverFilled from '../temp/CloverFilled.gen';
// Fluent icons. Eventually, the goal is for all icons to be from Fluent
// https://office.visualstudio.com/OC/_workitems/edit/5057269
import SvgFluentCopy20Regular from '../temp/FluentCopy20Regular.gen';
import SvgFluentCopy20Filled from '../temp/FluentCopy20Filled.gen';
import SvgFluentCopySelectRegular from '../temp/FluentCopySelect20Regular.gen';
import SvgFluentCopySelectFilled from '../temp/FluentCopySelect20Filled.gen';
import SvgFluentPeopleCheckmark20Regular from '../temp/FluentPeopleCheckmark20Regular.gen';
import SvgFluentPeopleCheckmark20Filled from '../temp/FluentPeopleCheckmark20Filled.gen';
import SvgFluentCheckmark20Regular from '../temp/FluentCheckmark20Regular.gen';
import SvgStatusTracker from '../temp/StatusTracker.gen';
import SvgFluentOutlookFilled from '../temp/FluentOutlookFilled.gen';
import SvgFluentTeamsFilled from '../temp/FluentTeamsFilled.gen';
import SvgFluentDelete20Regular from '../temp/FluentDelete20Regular.gen';
import SvgFluentDelete20Filled from '../temp/FluentDelete20Filled.gen';
import SvgFluentDismiss20Regular from '../temp/FluentDismiss20Regular.gen';
import SvgFluentDismiss20Filled from '../temp/FluentDismiss20Filled.gen';
import SvgFluentMoreHorizontalRegular from '../temp/FluentMoreHorizontalRegular.gen';
import SvgFluentMoreHorizontalFilled from '../temp/FluentMoreHorizontalFilled.gen';
import SvgFluentPanelLeftAdd24Regular from '../temp/FluentPanelLeftAdd24Regular.gen';
import SvgFluentPanelLeftAdd24Filled from '../temp/FluentPanelLeftAdd24Filled.gen';
import SvgFluentPanelRightAdd20Regular from '../temp/FluentPanelRightAdd20Regular.gen';
import SvgFluentPanelRightAdd20Filled from '../temp/FluentPanelRightAdd20Filled.gen';
import SvgCopyAnimated from '../svg/CopyAnimated';
import SvgLocationAnimated from '../svg/LocationAnimated';
import SvgFluentNewWindow20Regular from '../temp/FluentNewWindow20Regular.gen';
import SvgFluentNewWindow20Filled from '../temp/FluentNewWindow20Filled.gen';
import SvgFluentEyeSlash20Regular from '../temp/EyeSlash.gen';
import SvgFluentEyeSlash20Filled from '../temp/EyeFilledSlash.gen';
/**
 * Our icons require the FFX prefix to avoid collisions with the Fluent UI Icons.
 * You can find icon names or the raw SVGs on https://iconcloud.design
 */ const icons = {
    FFXInfo: /*#__PURE__*/ React.createElement(SvgInfo, null),
    FFXMore: /*#__PURE__*/ React.createElement(SvgMore, null),
    FFXUneditable: /*#__PURE__*/ React.createElement(SvgUneditable, null),
    FFXFabricFolder: /*#__PURE__*/ React.createElement(SvgFabricFolder, null),
    FFXAdd: /*#__PURE__*/ React.createElement(SvgAdd, null),
    FFXAddIn: /*#__PURE__*/ React.createElement(SvgAddIn, null),
    FFXError: /*#__PURE__*/ React.createElement(SvgError, null),
    FFXErrorBadge: /*#__PURE__*/ React.createElement(SvgErrorBadge, null),
    FFXChevronDown: /*#__PURE__*/ React.createElement(SvgChevronDown, null),
    FFXChevronLeft: /*#__PURE__*/ React.createElement(SvgChevronLeft, null),
    FFXChevronRight: /*#__PURE__*/ React.createElement(SvgChevronRight, null),
    FFXGroup: /*#__PURE__*/ React.createElement(SvgGroup, null),
    FFXCheckMark: /*#__PURE__*/ React.createElement(SvgCheckMark, null),
    FFXFluentCheckMark: /*#__PURE__*/ React.createElement(SvgFluentCheckmark20Regular, null),
    FFXCopyLink: /*#__PURE__*/ React.createElement(SvgCopy, null),
    FFXFluentCopyLinkRegular: /*#__PURE__*/ React.createElement(SvgFluentCopy20Regular, null),
    FFXFluentCopyLinkFilled: /*#__PURE__*/ React.createElement(SvgFluentCopy20Filled, null),
    FFXFluentCopySelectRegular: /*#__PURE__*/ React.createElement(SvgFluentCopySelectRegular, null),
    FFXFluentCopySelectFilled: /*#__PURE__*/ React.createElement(SvgFluentCopySelectFilled, null),
    FFXCopyAnimated: /*#__PURE__*/ React.createElement(SvgCopyAnimated, null),
    FFXLocationAnimated: /*#__PURE__*/ React.createElement(SvgLocationAnimated, null),
    FFXPeopleTrust: /*#__PURE__*/ React.createElement(SvgPeopleTrust, null),
    FFXFluentPeopleRegular: /*#__PURE__*/ React.createElement(SvgFluentPeopleCheckmark20Regular, null),
    FFXFluentPeopleFilled: /*#__PURE__*/ React.createElement(SvgFluentPeopleCheckmark20Filled, null),
    FFXFluentOutlookFilled: /*#__PURE__*/ React.createElement(SvgFluentOutlookFilled, null),
    FFXFluentTeamsFilled: /*#__PURE__*/ React.createElement(SvgFluentTeamsFilled, null),
    FFXCancel: /*#__PURE__*/ React.createElement(SvgCancel, null),
    FFXDelete: /*#__PURE__*/ React.createElement(SvgDelete, null),
    FFXFluentDeleteRegular: /*#__PURE__*/ React.createElement(SvgFluentDelete20Regular, null),
    FFXFluentDeleteFilled: /*#__PURE__*/ React.createElement(SvgFluentDelete20Filled, null),
    FFXFluentDismissRegular: /*#__PURE__*/ React.createElement(SvgFluentDismiss20Regular, null),
    FFXFluentDismissFilled: /*#__PURE__*/ React.createElement(SvgFluentDismiss20Filled, null),
    FFXFluentMoreHorizontalRegular: /*#__PURE__*/ React.createElement(SvgFluentMoreHorizontalRegular, null),
    FFXFluentMoreHorizontalFilled: /*#__PURE__*/ React.createElement(SvgFluentMoreHorizontalFilled, null),
    FFXFluentWindowNewRegular: /*#__PURE__*/ React.createElement(SvgFluentNewWindow20Regular, null),
    FFXFluentWindowNewFilled: /*#__PURE__*/ React.createElement(SvgFluentNewWindow20Filled, null),
    FFXFluentEyeSlashRegular: /*#__PURE__*/ React.createElement(SvgFluentEyeSlash20Regular, null),
    FFXFluentEyeSlashFilled: /*#__PURE__*/ React.createElement(SvgFluentEyeSlash20Filled, null),
    // Icons used in Shared UX
    FFXLoopFilled: /*#__PURE__*/ React.createElement(SvgLoopFilled, null),
    FFXLoopOutline: /*#__PURE__*/ React.createElement(SvgLoopOutline, null),
    FFXTeamsChat: /*#__PURE__*/ React.createElement(SvgTeamsChat, null),
    FFXQuestionCircle: /*#__PURE__*/ React.createElement(SvgQuestionCircle, null),
    FFXWord: /*#__PURE__*/ React.createElement(SvgWord, null),
    FFXWordColor: /*#__PURE__*/ React.createElement(SvgWordLogoColor, null),
    FFXPowerPoint: /*#__PURE__*/ React.createElement(SvgPowerPoint, null),
    FFXPowerPointColor: /*#__PURE__*/ React.createElement(SvgPowerPointLogoColor, null),
    FFXExcel: /*#__PURE__*/ React.createElement(SvgExcel, null),
    FFXExcelColor: /*#__PURE__*/ React.createElement(SvgExcelLogoColor, null),
    FFXConnectToWorkspace: /*#__PURE__*/ React.createElement(SvgConnectToWorkspace, null),
    FFXFoundInPlaces: /*#__PURE__*/ React.createElement(SvgFoundInPlaces, null),
    FFXOutlookMail: /*#__PURE__*/ React.createElement(SvgOutlookMail, null),
    FFXShared: /*#__PURE__*/ React.createElement(SvgShared, null),
    FFXShare: /*#__PURE__*/ React.createElement(SvgShare, null),
    FFXInformation: /*#__PURE__*/ React.createElement(SvgInformation, null),
    FFXFluentPanelLeftAddRegular: /*#__PURE__*/ React.createElement(SvgFluentPanelLeftAdd24Regular, null),
    FFXFluentPanelLeftAddFilled: /*#__PURE__*/ React.createElement(SvgFluentPanelLeftAdd24Filled, null),
    FFXFluentPanelRightAddRegular: /*#__PURE__*/ React.createElement(SvgFluentPanelRightAdd20Regular, null),
    FFXFluentPanelRightAddFilled: /*#__PURE__*/ React.createElement(SvgFluentPanelRightAdd20Filled, null),
    FFXClover: /*#__PURE__*/ React.createElement(SvgClover, null),
    FFXCloverFilled: /*#__PURE__*/ React.createElement(SvgCloverFilled, null),
    // Fluid Discover Menu Icons Used In Manifest File
    FFXCCompleted: /*#__PURE__*/ React.createElement(SvgCompleted, null),
    FFXCClipboardList: /*#__PURE__*/ React.createElement(SvgClipboardList, null),
    FFXCBulletedList: /*#__PURE__*/ React.createElement(SvgBulletedList, null),
    FFXCChecklist: /*#__PURE__*/ React.createElement(SvgCheckList, null),
    FFXCNumberedList: /*#__PURE__*/ React.createElement(SvgNumberedList, null),
    FFXCInsertTextBox: /*#__PURE__*/ React.createElement(SvgInsertTextBox, null),
    FFXCTable: /*#__PURE__*/ React.createElement(SvgTable, null),
    FFXQuestionAnswer: /*#__PURE__*/ React.createElement(SvgClipboardListQuestion, null),
    FFXCVote: /*#__PURE__*/ React.createElement(SvgVote, null),
    FFXCStatusTracker: /*#__PURE__*/ React.createElement(SvgStatusTracker, null),
    FFXCTrello: /*#__PURE__*/ React.createElement(SvgTrello, null),
    FFXCJira: /*#__PURE__*/ React.createElement(SvgJira, null),
    // InformationProtection
    FFXCOpen: /*#__PURE__*/ React.createElement(SvgOpen, null),
    // Link Style
    FFXLinkCardActive: /*#__PURE__*/ React.createElement(SvgLinkCardActive, null),
    FFXLinkCardRest: /*#__PURE__*/ React.createElement(SvgLinkCardRest, null),
    FFXLinkUrlActive: /*#__PURE__*/ React.createElement(SvgLinkUrlActive, null),
    FFXLinkUrlRest: /*#__PURE__*/ React.createElement(SvgLinkUrlRest, null),
    FFXLoopIcon: /*#__PURE__*/ React.createElement(SvgLoopIcon, null)
};
export const SvgFfxHostUxIcons = {
    name: 'ffx-host-ux',
    icons
};
